export const GET_SECURITY_DONGLES_REQUEST = 'GET_SECURITY_DONGLES_REQUEST';
export const GET_SECURITY_DONGLES_SUCCESS = 'GET_SECURITY_DONGLES_SUCCESS';
export const GET_SECURITY_DONGLES_FAILURE = 'GET_SECURITY_DONGLES_FAILURE';

export const CREATE_SECURITY_DONGLES_REQUEST = 'CREATE_SECURITY_DONGLES_REQUEST';
export const CREATE_SECURITY_DONGLES_SUCCESS = 'CREATE_SECURITY_DONGLES_SUCCESS';
export const CREATE_SECURITY_DONGLES_FAILURE = 'CREATE_SECURITY_DONGLES_FAILURE';
